import {Button, Card, Select} from "antd";
import {useEffect, useRef, useState} from "react";
import {GetMessageCodeList} from "../Components/Output/MessageCodes";
import ApiService from "../Service/ApiService";
import TinymceEditor from "../Components/TinymceEditor";
import {c} from "plotly.js/src/traces/scatterternary/attributes";

export default function InfoContentPage() {
    const messages = GetMessageCodeList()
    const [code, setCode] = useState('')
    const [info, setInfo] = useState('')
    const modifiedInfo = useRef('')

    const getInfo = async (key, code) => {
        const res = await ApiService.RasCheck.GetMessageInfo({
            messageCode: code,
            topic: key
        });

        if(res.success) {
            setInfo(res.data)
            modifiedInfo.current = res.data
        }
    }

    useEffect(() => {
        const msg = messages.find(x => x.error_id_text)
        setCode(`${msg.key}_${msg.error_id_text}`)

    }, []);

    useEffect(() => {
        const msg = messages.find(x => `${x.key}_${x.error_id_text}` === code)
        if(msg) {
            getInfo(msg?.key, msg.error_id_text)
        }
    }, [code]);

    return (
        <Card
            title={'Info Content'}
            style={{margin: 16}}
        >
            <div style={{display: 'flex', alignItems: 'center', gap: 8, marginBottom: 16}}>
                <Select
                    style={{width: 250}}
                    value={code}
                    showSearch={true}
                    filterOption={(inputValue, option) => {
                        return option?.children?.toLowerCase().includes(inputValue.toLowerCase())
                    }}
                    onChange={(e) => setCode(e)}
                >
                    {
                        messages.map((m, idx) => (
                            <Select.Option key={idx} value={`${m.key}_${m.error_id_text}`}>
                                {`${m.key} - ${m.error_id_text || m.error_id}`}
                            </Select.Option>
                        ))
                    }
                </Select>
                <Button
                    type={'primary'}
                    onClick={async () => {
                        const msg = messages.find(x => `${x.key}_${x.error_id_text}` === code)
                        if(msg) {
                            const res = await ApiService.RasCheck.UpdateMessageInfo({
                                messageCode: msg.error_id_text,
                                topic: msg.key,
                                infoContent: modifiedInfo.current
                            })
                            if (res.success) {

                            }
                        }
                    }}
                >
                    Save
                </Button>
            </div>
            <TinymceEditor
                height={'60vh'}
                value={info}
                handleChange={(val) => {
                    modifiedInfo.current = val
                }}
            />
        </Card>
    )
}